(function () {
  'use strict';

  /* ---- Size Guide Popup Event Listener ---- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-size-guide-trigger]');
    if (trigger) {
      e.preventDefault();
      var sgPopup = document.getElementById('size-guide-popup');
      if (sgPopup) {
        sgPopup.classList.add('is-open');
        sgPopup.setAttribute('aria-hidden', 'false');
        sgPopup.style.zIndex = '999999';
      }
    }

    var closeBtn = e.target.closest('[data-size-guide-close]');
    if (closeBtn) {
      e.preventDefault();
      var sgPopup = document.getElementById('size-guide-popup');
      if (sgPopup) {
        sgPopup.classList.remove('is-open');
        sgPopup.setAttribute('aria-hidden', 'true');
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var sgPopup = document.getElementById('size-guide-popup');
      if (sgPopup && sgPopup.classList.contains('is-open')) {
        sgPopup.classList.remove('is-open');
        sgPopup.setAttribute('aria-hidden', 'true');
      }
    }
  });
  if (window.productCardJsLoaded) return;
  window.productCardJsLoaded = true;

  document.addEventListener('click', function (e) {
    var moreBtn = e.target.closest('.product-card__swatch-more, .product-swatches__more');
    if (moreBtn) {
      e.preventDefault();
      e.stopPropagation();
      var swatchesWrap = moreBtn.closest('.product-card__swatches, .product-swatches__wrapper');
      if (swatchesWrap) {
        swatchesWrap.classList.add('is-expanded');
      }
      return;
    }

    var swatch = e.target.closest('.product-card__swatch');
    if (!swatch) return;

    e.preventDefault();

    var card = swatch.closest('.product-card');
    if (!card) return;

    var img = card.querySelector('.product-card__img');
    var imageUrl = swatch.dataset.imageUrl || swatch.dataset.cardImage;
    if (img && imageUrl) {
      img.removeAttribute('srcset');
      img.src = imageUrl;
      img.alt = swatch.dataset.colorName || swatch.dataset.cardImageAlt || img.alt;
    }

    card.querySelectorAll('.product-card__swatch').forEach(function (btn) {
      btn.classList.toggle('is-active', btn === swatch);
    });

    var label = card.querySelector('.product-card__swatches-label');
    var colorName = swatch.dataset.colorName || swatch.dataset.optVal;
    if (label && colorName) {
      label.textContent = colorName;
    }
  });

  /* Hover: preview color name on the card label only (do not change image) */
  function setCardSwatchLabel(card, text) {
    var label = card.querySelector('.product-card__swatches-label');
    if (!label) return;
    label.textContent = text || label.dataset.defaultLabel || '';
  }

  function cardSwatchLabelText(swatch) {
    return swatch.dataset.colorName || swatch.dataset.optVal || '';
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.product-card__swatch');
    if (!swatch) return;
    if (e.relatedTarget && swatch.contains(e.relatedTarget)) return;
    var card = swatch.closest('.product-card');
    if (!card) return;
    var name = cardSwatchLabelText(swatch);
    if (name) setCardSwatchLabel(card, name);
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('.product-card__swatch');
    if (!swatch) return;
    if (e.relatedTarget && swatch.contains(e.relatedTarget)) return;
    var card = swatch.closest('.product-card');
    if (!card) return;
    var active = card.querySelector('.product-card__swatch.is-active');
    if (active) {
      setCardSwatchLabel(card, cardSwatchLabelText(active));
    } else {
      setCardSwatchLabel(card, '');
    }
  });


  /* ================================================================
     COUNTDOWN TIMERS
     Looks for [data-countdown] elements and ticks them down.
  ================================================================ */
  function hideFlashSaleSectionEl(sectionEl) {
    if (!sectionEl) return;

    var target = sectionEl.closest('.shopify-section') || sectionEl;
    if (target.dataset.flashSaleHiding === '1') return;
    target.dataset.flashSaleHiding = '1';

    var startHeight = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = startHeight + 'px';
    target.style.opacity = '1';
    target.style.transition = 'opacity 0.55s ease, height 0.55s ease, margin 0.55s ease, padding 0.55s ease';
    /* Force reflow so the transition starts from the current height. */
    void target.offsetHeight;

    target.style.opacity = '0';
    target.style.height = '0px';
    target.style.marginTop = '0';
    target.style.marginBottom = '0';
    target.style.paddingTop = '0';
    target.style.paddingBottom = '0';

    var done = false;
    function finishHide() {
      if (done) return;
      done = true;
      target.hidden = true;
      target.style.display = 'none';
      sectionEl.hidden = true;
      sectionEl.style.display = 'none';
    }

    target.addEventListener('transitionend', finishHide, { once: true });
    setTimeout(finishHide, 650);
  }

  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      if (el.dataset.countdownBound === '1') return;
      el.dataset.countdownBound = '1';

      var startTime = el.dataset.countdownStart ? parseCountdownDate(el.dataset.countdownStart) : NaN;
      var endTime = parseCountdownDate(el.dataset.countdown);
      if (isNaN(endTime)) return;

      var numH = el.querySelector('[data-cd="h"]');
      var numM = el.querySelector('[data-cd="m"]');
      var numS = el.querySelector('[data-cd="s"]');

      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

      /* - sebelum start → 00:00:00
         - selama sale  → sisa waktu sampai end
         - setelah end  → hide section */
      function getRemainingMs() {
        var now = Date.now();
        if (!isNaN(startTime) && now < startTime) return 0;
        if (now >= endTime) return 0;
        return endTime - now;
      }

      function tick() {
        var now = Date.now();
        var diff = getRemainingMs();
        /* Jam dibatasi siklus 24 jam (maks 23:59:59), bukan total jam. */
        var hours = Math.floor(diff / 3600000) % 24;
        if (numH) numH.textContent = pad(hours);
        if (numM) numM.textContent = pad(Math.floor((diff % 3600000) / 60000));
        if (numS) numS.textContent = pad(Math.floor((diff % 60000) / 1000));

        if (now >= endTime) {
          hideFlashSaleSectionEl(
            el.closest('[data-flash-sale-section]') || el.closest('.featured-products--flash')
          );
          return;
        }
        setTimeout(tick, 1000);
      }

      tick();
    });

    /* Hide flash sale when end passes (works even if countdown toggle is off) */
    document.querySelectorAll('[data-flash-sale-section]').forEach(function (sectionEl) {
      if (sectionEl.dataset.flashSaleBound === '1') return;
      sectionEl.dataset.flashSaleBound = '1';

      var endTime = parseCountdownDate(sectionEl.getAttribute('data-flash-sale-end'));
      if (isNaN(endTime)) return;

      function checkFlashSaleVisibility() {
        if (Date.now() >= endTime) {
          hideFlashSaleSectionEl(sectionEl);
          return;
        }
        setTimeout(checkFlashSaleVisibility, 1000);
      }

      checkFlashSaleVisibility();
    });
  }

  function parseCountdownDate(value) {
    if (!value) return NaN;

    var normalized = String(value).replace(/\u00a0/g, ' ').trim();
    var dateMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})[.\sT]+(\d{1,2}):(\d{2})(?::(\d{2}))?$/);

    if (dateMatch) {
      return new Date(
        parseInt(dateMatch[1], 10),
        parseInt(dateMatch[2], 10) - 1,
        parseInt(dateMatch[3], 10),
        parseInt(dateMatch[4], 10),
        parseInt(dateMatch[5], 10),
        dateMatch[6] ? parseInt(dateMatch[6], 10) : 0
      ).getTime();
    }

    var parsed = new Date(normalized.replace(' ', 'T')).getTime();
    return parsed;
  }

  /* ================================================================
     FEATURED PRODUCT CAROUSELS
     Scroll-based carousel with prev/next arrows.
  ================================================================ */
  function initFeaturedCarousels() {
    document.querySelectorAll('[data-fp-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-fp-track]');
      var prevBtn = wrap.querySelector('[data-fp-prev]');
      var nextBtn = wrap.querySelector('[data-fp-next]');
      if (!track) return;

      function scrollBy(dir) {
        var card = track.querySelector('.product-card');
        var step = card ? (card.offsetWidth + 16) * 2 : 432;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollBy(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollBy(1); });
    });
  }

  /* ================================================================
     VARIANT POPUP
     Opens when a "Select Variant" button is clicked.
     Fetches product JSON, builds option selectors, handles ATC.
  ================================================================ */
  var popup, popOverlay, popClose, popTitle, popSku, popPriceRange, popFinalPrice, popStock, popOptions, popQtyInput, popQtyDec, popQtyInc, popAtcBtn, popGallery, popDots;
  var popupInitialized = false;

  function initPopupElements() {
    if (popupInitialized && popup) return popup;
    popup = document.getElementById('variant-popup');
    if (!popup) return null;

    popOverlay = popup.querySelector('.variant-popup__overlay');
    popClose = popup.querySelector('.variant-popup__close');
    popTitle = popup.querySelector('[data-vp-title]');
    popSku = popup.querySelector('[data-vp-sku]');
    popPriceRange = popup.querySelector('[data-vp-price-range]');
    popFinalPrice = popup.querySelector('[data-vp-final-price]');
    popStock = popup.querySelector('[data-vp-stock]');
    popOptions = popup.querySelector('[data-vp-options]');
    popQtyInput = popup.querySelector('[data-vp-qty]');
    popQtyDec = popup.querySelector('[data-vp-qty-dec]');
    popQtyInc = popup.querySelector('[data-vp-qty-inc]');
    popAtcBtn = popup.querySelector('[data-vp-atc]');
    popGallery = popup.querySelector('[data-vp-gallery]');
    popDots = popup.querySelector('[data-vp-dots]');

    if (popClose) popClose.addEventListener('click', closePopup);
    if (popOverlay) popOverlay.addEventListener('click', closePopup);

    if (popQtyDec) {
      popQtyDec.addEventListener('click', function () {
        var v = parseInt(popQtyInput ? popQtyInput.value : 1, 10) || 1;
        if (v > 1 && popQtyInput) popQtyInput.value = v - 1;
      });
    }
    if (popQtyInc) {
      popQtyInc.addEventListener('click', function () {
        var v = parseInt(popQtyInput ? popQtyInput.value : 1, 10) || 1;
        if (popQtyInput) popQtyInput.value = v + 1;
      });
    }

    if (popAtcBtn) {
      popAtcBtn.addEventListener('click', function () {
        var variantId = popAtcBtn.dataset.variantId;
        if (!variantId) return;

        /* Gift-With-Purchase mode: cart.liquid flags the popup with a tier id
           before opening it (see openVariantPopupForGift). Add qty is always
           1 and the line carries the tier property so cart.liquid can track
           it; closePopup()'s own cleanup notifies cart.liquid via the
           __gwpOnGiftClaimed/__gwpOnPopupSkipped hooks. */
        if (popup.dataset.gwpTierId) {
          var tierId = popup.dataset.gwpTierId;
          addToCart(variantId, 1, popAtcBtn, function () {
            popup.dataset.gwpClaimed = 'true';
            closePopup();
            if (typeof window.__gwpOnGiftClaimed === 'function') window.__gwpOnGiftClaimed(tierId);
          }, { _bohopana_gwp_tier: tierId });
          return;
        }

        var qty = parseInt(popQtyInput ? popQtyInput.value : 1, 10) || 1;
        addToCart(variantId, qty, popAtcBtn, function () {
          closePopup();
        });
      });
    }

    popupInitialized = true;
    return popup;
  }

  var currentProduct = null;
  var selectedOptions = {};
  var galleryImages = [];
  var currentImg = 0;

  var scrollTopPos = 0;

  function openPopup() {
    initPopupElements();
    if (!popup) return;
    scrollTopPos = window.scrollY;
    popup.classList.add('is-open');
    popup.removeAttribute('aria-hidden');

    // Scroll lock to prevent background jumping to top
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollTopPos + 'px';
    document.body.style.width = '100%';

    document.body.classList.add('variant-popup-open');
    document.documentElement.classList.add('variant-popup-open');
    var popBody = popup.querySelector('.variant-popup__body');
    var popDetails = popup.querySelector('.variant-popup__details');
    if (popBody) popBody.scrollTop = 0;
    if (popDetails) popDetails.scrollTop = 0;
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');

    // Release scroll lock
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    document.body.classList.remove('variant-popup-open');
    document.documentElement.classList.remove('variant-popup-open');

    window.scrollTo(0, scrollTopPos);

    currentProduct = null;
    selectedOptions = {};
    galleryImages = [];

    var wasGiftTierId = popup.dataset.gwpTierId;
    var wasClaimed = popup.dataset.gwpClaimed === 'true';
    delete popup.dataset.gwpTierId;
    delete popup.dataset.gwpClaimed;
    popup.classList.remove('gwp-variant-mode');

    if (wasGiftTierId && !wasClaimed && typeof window.__gwpOnPopupSkipped === 'function') {
      window.__gwpOnPopupSkipped(wasGiftTierId);
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup && popup.classList.contains('is-open')) closePopup();
  });

  /* Delegate "Select Variant" button clicks */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vp-open]');
    if (!btn) return;
    e.preventDefault();

    var handle = btn.dataset.vpOpen;
    if (!handle) return;

    var pop = initPopupElements();
    if (!pop) return;

    var isNew = btn.dataset.vpNew === 'true';
    var customLabel = (btn.dataset.vpLabel || '').trim();
    var isDiscount = btn.dataset.vpDiscount === 'true';
    var discountPercent = btn.dataset.vpDiscountPercent || '0';

    var badgeNew = pop.querySelector('.variant-popup__badge--new');
    var badgeDiscount = pop.querySelector('.variant-popup__badge--discount');

    if (badgeNew) {
      if (customLabel) {
        badgeNew.textContent = customLabel.replace(/[-_]+/g, ' ').toUpperCase();
        badgeNew.style.display = 'inline-block';
      } else if (isNew) {
        badgeNew.textContent = 'New';
        badgeNew.style.display = 'inline-block';
      } else {
        badgeNew.style.display = 'none';
      }
    }
    if (badgeDiscount) {
      badgeDiscount.style.display = (isDiscount && !customLabel && !isNew) ? 'inline-block' : 'none';
      if (isDiscount) {
        badgeDiscount.textContent = '-' + discountPercent + '%';
      }
    }

    loadProduct(handle);
  });

  /* Delegate "Add to Cart" direct clicks (no-variant products) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-atc-id]');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.dataset.atcId;
    if (!variantId) return;
    addToCart(variantId, 1, btn, function () {
      showAddedState(btn);
    });
  });

  function loadProduct(handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        /* Gift-With-Purchase mode + no real choice to make (0 or 1 variant):
           skip the confirmation popup entirely and add it straight to cart,
           instead of making the shopper click through a screen with nothing
           to pick. Mirrors the popup's own ATC gift branch. */
        var variants = product.variants || [];
        if (popup && popup.dataset.gwpTierId && variants.length <= 1) {
          var tierId = popup.dataset.gwpTierId;
          var variant = variants[0];
          popup.classList.remove('gwp-variant-mode');
          if (!variant) {
            delete popup.dataset.gwpTierId;
            alert('Could not load product. Please try again.');
            return;
          }
          addToCart(variant.id, 1, null, function () {
            delete popup.dataset.gwpTierId;
            delete popup.dataset.gwpClaimed;
            if (typeof window.__gwpOnGiftClaimed === 'function') window.__gwpOnGiftClaimed(tierId);
          }, { _bohopana_gwp_tier: tierId });
          return;
        }

        currentProduct = product;
        selectedOptions = {};
        populatePopup(product);
        openPopup();
      })
      .catch(function () {
        alert('Could not load product. Please try again.');
      });
  }

  function populatePopup(product) {
    /* Title + SKU */
    if (popTitle) popTitle.textContent = product.title;
    if (popSku) popSku.textContent = product.variants[0] && product.variants[0].sku
      ? 'SKU: ' + product.variants[0].sku
      : '';

    /* Price range — show sale price + compare at price */
    if (popPriceRange) {
      var prices = product.variants.map(function (v) { return v.price; });
      var minP = Math.min.apply(null, prices);
      var maxP = Math.max.apply(null, prices);
      var rangeText = minP === maxP
        ? formatMoney(minP)
        : 'Mulai dari ' + formatMoney(minP);
      popPriceRange.textContent = rangeText;
    }
    /* Hide final price until a variant is chosen */
    if (popFinalPrice) popFinalPrice.textContent = '';
    if (popStock) popStock.textContent = '';

    /* Gallery */
    galleryImages = product.images || [];
    currentImg = 0;
    renderGallery();

    /* Options */
    renderOptions(product);
    updatePopupOptionAvailability();

    /* Determine if product has real variant options to pick */
    var hasRealOptions = product.options && product.options.length > 0 &&
      !(product.options.length === 1 && (getOptName(product.options[0]) === 'Title' || getOptName(product.options[0]) === 'Default Title'));

    if (hasRealOptions) {
      selectedOptions = {};
      if (popAtcBtn) {
        popAtcBtn.disabled = true;
        popAtcBtn.textContent = 'CHOOSE VARIANT';
        delete popAtcBtn.dataset.variantId;
      }
      markActiveOptions();
    } else {
      /* Single variant product without choices */
      var firstAvail = product.variants.find(function (v) { return v.available; })
        || product.variants[0];
      if (firstAvail) {
        product.options.forEach(function (opt, i) {
          var name = getOptName(opt);
          var val = firstAvail['option' + (i + 1)] || (firstAvail.options && firstAvail.options[i]);
          selectedOptions[name] = val;
        });
        updateForVariant(firstAvail);
        markActiveOptions();
      }
    }

    /* Reset qty */
    if (popQtyInput) popQtyInput.value = 1;
  }

  /* ---- Gallery ---- */
  function renderGallery() {
    if (!popGallery) return;

    // Remove any static img that might be in the markup
    var staticImg = popGallery.querySelector('.variant-popup__gallery-img:not(.variant-popup__gallery-track *)');
    if (staticImg) {
      staticImg.remove();
    }

    var track = popGallery.querySelector('.variant-popup__gallery-track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'variant-popup__gallery-track';
      popGallery.insertBefore(track, popDots);
    }
    track.innerHTML = '';

    if (galleryImages.length > 0) {
      galleryImages.forEach(function (imgSrc) {
        var img = document.createElement('img');
        img.className = 'variant-popup__gallery-img';
        img.src = imgSrc;
        img.alt = currentProduct ? currentProduct.title : '';
        img.setAttribute('loading', 'lazy');
        track.appendChild(img);
      });
    }

    // Scroll to the first image initially
    track.scrollLeft = 0;

    /* Dots */
    if (popDots) {
      popDots.innerHTML = '';
      if (galleryImages.length > 1) {
        galleryImages.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'variant-popup__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Image ' + (i + 1));
          dot.addEventListener('click', function () { goToGalleryImg(i); });
          popDots.appendChild(dot);
        });
      }
    }

    // Add scroll event listener to track to update active dot on swipe/scroll
    track.addEventListener('scroll', function () {
      // Only trigger if not currently dragging via mouse to avoid scroll conflicts
      if (isDown) return;
      var width = track.clientWidth;
      if (width === 0) return;
      var newActive = Math.round(track.scrollLeft / width);
      if (newActive !== currentImg) {
        currentImg = newActive;
        updateDots(newActive);
      }
    });

    // Drag-to-scroll behavior for desktop mouse users
    var isDown = false;
    var startX;
    var scrollLeft;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
    });

    track.addEventListener('mouseleave', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      track.style.scrollBehavior = 'smooth';
      track.style.scrollSnapType = 'x mandatory';
      snapToClosest();
    });

    track.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      track.style.scrollBehavior = 'smooth';
      track.style.scrollSnapType = 'x mandatory';
      snapToClosest();
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.5; // Drag speed multiplier
      track.scrollLeft = scrollLeft - walk;
    });

    // Prevent default browser image dragging
    track.querySelectorAll('.variant-popup__gallery-img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });

    function snapToClosest() {
      var width = track.clientWidth;
      if (width === 0) return;
      var targetIdx = Math.round(track.scrollLeft / width);
      track.scrollTo({
        left: targetIdx * width,
        behavior: 'smooth'
      });
      currentImg = targetIdx;
      updateDots(targetIdx);
    }
  }

  function goToGalleryImg(idx) {
    currentImg = idx;
    var track = popGallery ? popGallery.querySelector('.variant-popup__gallery-track') : null;
    if (track) {
      var width = track.clientWidth;
      track.scrollTo({
        left: idx * width,
        behavior: 'smooth'
      });
    }
    updateDots(idx);
  }

  function updateDots(idx) {
    if (popDots) {
      popDots.querySelectorAll('.variant-popup__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }
  }


  /* ---- Option selectors ---- */

  /* Shopify AJAX API returns options as objects {name, position, values} OR strings */
  function getOptName(opt) {
    return typeof opt === 'object' && opt !== null ? opt.name : String(opt);
  }

  function renderOptions(product) {
    if (!popOptions) return;
    popOptions.innerHTML = '';

    product.options.forEach(function (opt, optIdx) {
      var optionName = getOptName(opt);
      var displayName = optionName.toLowerCase() === 'color' ? 'warna' : optionName;
      var isSize = /size|ukuran/i.test(optionName);
      var values = getOptionValues(product, optIdx);
      var isColor = /colou?r|shade|warna/i.test(optionName);

      var group = document.createElement('div');
      group.className = 'variant-popup__option';

      var label = document.createElement('div');
      label.className = 'variant-popup__option-label';
      if (isSize) {
        label.innerHTML = '<span>' + displayName + ': <span data-vp-opt-val="' + optIdx + '"></span></span><button type="button" class="variant-popup__size-guide" data-size-guide-trigger>Panduan Ukuran</button>';
      } else {
        label.innerHTML = displayName + ': <span data-vp-opt-val="' + optIdx + '"></span>';
      }
      group.appendChild(label);

      var swatchWrap = document.createElement('div');
      swatchWrap.className = isColor ? 'variant-popup__swatches' : 'variant-popup__pills';
      swatchWrap.dataset.optIdx = optIdx;

      values.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.optIdx = optIdx;
        btn.dataset.optVal = val;
        btn.dataset.optName = optionName;

        if (isColor) {
          btn.className = 'variant-popup__swatch';
          var swatchBg, swatchLabel;
          if (val.indexOf('_') !== -1) {
            var parts = val.split('_');
            swatchBg = '#' + parts[0];
            swatchLabel = parts.slice(1).join('_');
          } else {
            var variantWithColor = product.variants.find(function (v) {
              return v.options[optIdx] === val;
            });
            var swatchImg = null;
            if (variantWithColor) {
              if (variantWithColor.featured_image) {
                swatchImg = variantWithColor.featured_image.src;
              } else if (product.featured_image) {
                swatchImg = product.featured_image;
              }
            }
            if (swatchImg) {
              swatchBg = 'url(' + swatchImg + ') center/cover no-repeat';
            } else {
              var lowerVal = val.toLowerCase();
              if (lowerVal === 'coklat') swatchBg = '#9B654B';
              else if (lowerVal === 'abu') swatchBg = '#8E9CA7';
              else swatchBg = val;
            }
            swatchLabel = val;
          }
          btn.style.setProperty('--swatch-bg', swatchBg);
          btn.setAttribute('aria-label', swatchLabel);
          btn.dataset.label = swatchLabel;

          if (!isOptionValueAvailable(product, optIdx, val)) {
            btn.classList.add('is-disable');
            btn.innerHTML = '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M38.707 0.707153L0.707031 38.7072" stroke="#8F9AA3" stroke-width="2"/></svg>';
          }
        } else {
          btn.className = 'variant-popup__pill';
          btn.textContent = val;
        }

        btn.addEventListener('click', function () {
          selectedOptions[optionName] = val;
          markActiveOptions();
          updatePopupOptionAvailability();
          var matched = findMatchingVariant();
          if (matched) {
            updateForVariant(matched);
            if (matched.featured_image && matched.featured_image.position) {
              var imgIdx = matched.featured_image.position - 1;
              if (imgIdx >= 0 && imgIdx < galleryImages.length) {
                goToGalleryImg(imgIdx);
              }
            }
          } else {
            if (popAtcBtn) {
              popAtcBtn.disabled = true;
              popAtcBtn.textContent = 'CHOOSE VARIANT';
              delete popAtcBtn.dataset.variantId;
            }
          }
        });

        if (isColor) {
          btn.addEventListener('mouseenter', function () {
            var span = popOptions.querySelector('[data-vp-opt-val="' + optIdx + '"]');
            if (!span) return;
            span.textContent = btn.dataset.label || (
              val.indexOf('_') !== -1 ? val.split('_').slice(1).join('_') : val
            );
          });

          btn.addEventListener('mouseleave', function () {
            var span = popOptions.querySelector('[data-vp-opt-val="' + optIdx + '"]');
            if (!span) return;
            var raw = selectedOptions[optionName] || '';
            span.textContent = (raw.indexOf('_') !== -1)
              ? raw.split('_').slice(1).join('_')
              : raw;
          });
        }

        swatchWrap.appendChild(btn);
      });

      group.appendChild(swatchWrap);
      popOptions.appendChild(group);
    });
  }

  function getOptionValues(product, optIdx) {
    var vals = [];
    product.variants.forEach(function (v) {
      var val = v['option' + (optIdx + 1)] || (v.options && v.options[optIdx]);
      if (val && vals.indexOf(val) === -1) vals.push(val);
    });
    return vals;
  }

  function isOptionValueAvailable(product, optIdx, val) {
    return product.variants.some(function (v) {
      var vVal = v['option' + (optIdx + 1)] || (v.options && v.options[optIdx]);
      return vVal === val && v.available;
    });
  }

  function updatePopupOptionAvailability() {
    if (!popOptions || !currentProduct) return;

    popOptions.querySelectorAll('[data-opt-name]').forEach(function (btn) {
      var optIdx = parseInt(btn.dataset.optIdx, 10);
      var btnVal = btn.dataset.optVal;
      var isAvailable = currentProduct.variants.some(function (v) {
        var vVal = v['option' + (optIdx + 1)] || (v.options && v.options[optIdx]);
        if (vVal !== btnVal) return false;
        if (!v.available) return false;

        return currentProduct.options.every(function (opt, i) {
          if (i === optIdx) return true;
          var name = getOptName(opt);
          var selected = selectedOptions[name];
          if (!selected) return true;
          var otherVal = v['option' + (i + 1)] || (v.options && v.options[i]);
          return otherVal === selected;
        });
      });

      if (btn.classList.contains('variant-popup__swatch')) {
        btn.classList.toggle('is-disable', !isAvailable);
        var svg = btn.querySelector('svg');
        if (!isAvailable && !svg) {
          btn.insertAdjacentHTML('beforeend', '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M38.707 0.707153L0.707031 38.7072" stroke="#8F9AA3" stroke-width="2"/></svg>');
        } else if (isAvailable && svg) {
          svg.remove();
        }
      } else {
        btn.classList.toggle('is-unavailable', !isAvailable);
      }
    });
  }

  function markActiveOptions() {
    if (!popOptions) return;
    popOptions.querySelectorAll('[data-opt-name]').forEach(function (btn) {
      var optName = btn.dataset.optName;
      var isActive = selectedOptions[optName] === btn.dataset.optVal;
      btn.classList.toggle('is-active', isActive);
    });

    popOptions.querySelectorAll('[data-vp-opt-val]').forEach(function (span) {
      var optIdx = parseInt(span.dataset.vpOptVal, 10);
      var optName = getOptName(currentProduct.options[optIdx]);
      var raw = selectedOptions[optName] || '';
      var display = (raw.indexOf('_') !== -1) ? raw.split('_').slice(1).join('_') : raw;
      span.textContent = display;
    });
  }

  function findMatchingVariant() {
    if (!currentProduct) return null;

    var firstOptName = getOptName(currentProduct.options[0]);
    if (!selectedOptions[firstOptName]) {
      return null;
    }

    var allSelected = currentProduct.options.every(function (opt) {
      var name = getOptName(opt);
      return selectedOptions[name] !== undefined && selectedOptions[name] !== '';
    });

    if (allSelected) {
      return currentProduct.variants.find(function (v) {
        return currentProduct.options.every(function (opt, i) {
          var name = getOptName(opt);
          var vVal = v['option' + (i + 1)] || (v.options && v.options[i]);
          return vVal === selectedOptions[name];
        });
      }) || null;
    }

    if (Object.keys(selectedOptions).length === 1 && currentProduct.options.length > 1) {
      var firstOptVal = selectedOptions[firstOptName];
      return currentProduct.variants.find(function (v) {
        return (v.option1 === firstOptVal || (v.options && v.options[0] === firstOptVal)) && v.available;
      }) || currentProduct.variants.find(function (v) {
        return v.option1 === firstOptVal || (v.options && v.options[0] === firstOptVal);
      }) || null;
    }

    return null;
  }

  function updateForVariant(variant) {
    /* Update price range with selected variant price */
    if (popPriceRange) {
      popPriceRange.textContent = formatMoney(variant.price);
    }

    /* Final price — shown below options on mobile */
    if (popFinalPrice) {
      popFinalPrice.textContent = formatMoney(variant.price);
    }
    /* Stock info — show inventory count from global window.variantInventories mapping */
    if (popStock) {
      var localQty = window.variantInventories && window.variantInventories[variant.id];
      if (typeof localQty === 'number') {
        popStock.textContent = localQty + ' in stock';
      } else if (typeof variant.inventory_quantity === 'number') {
        popStock.textContent = variant.inventory_quantity + ' in stock';
      } else {
        popStock.textContent = '';
      }
    }
    /* SKU */
    if (popSku && variant.sku) popSku.textContent = 'SKU: ' + variant.sku;

    /* ATC button */
    if (popAtcBtn) {
      if (variant.available) {
        popAtcBtn.disabled = false;
        popAtcBtn.textContent = popup.dataset.gwpTierId ? 'CLAIM FREE GIFT' : 'ADD TO BAG';
        popAtcBtn.dataset.variantId = variant.id;
      } else {
        popAtcBtn.disabled = true;
        popAtcBtn.textContent = 'OUT OF STOCK';
        delete popAtcBtn.dataset.variantId;
      }
    }
  }

  /* ATC from popup */
  if (popAtcBtn) {
    popAtcBtn.addEventListener('click', function () {
      var variantId = popAtcBtn.dataset.variantId;
      if (!variantId) return;
      var qty = parseInt(popQtyInput ? popQtyInput.value : 1, 10) || 1;
      addToCart(variantId, qty, popAtcBtn, function () {
        closePopup();
      });
    });
  }

  /* ---- Add to Cart (AJAX) ---- */
  function addToCart(variantId, qty, btn, onSuccess, properties) {
    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    }

    var cartPage = document.querySelector('.cart-page');
    var sectionEl = cartPage ? cartPage.closest('.shopify-section') : null;
    var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;

    var payload = { id: variantId, quantity: qty };
    if (sectionId) {
      payload.sections = sectionId;
    }
    if (properties) {
      payload.properties = properties;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            throw new Error(data && data.description ? data.description : 'Could not add to cart.');
          }
          return data;
        });
      })
      .then(function (data) {
        if (cartPage || window.location.pathname.indexOf('/cart') !== -1) {
          window.location.href = '/cart';
          return;
        }

        if (window.BohopanaCart && typeof window.BohopanaCart.refreshFromCart === 'function') {
          window.BohopanaCart.refreshFromCart({ showNotice: true });
        } else {
          updateCartCount();
        }
        if (onSuccess) onSuccess();

        if (data && data.sections && sectionId && data.sections[sectionId]) {
          updateCartPageHTML(data.sections[sectionId]);
        }
      })
      .catch(function (error) {
        alert(error.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      });
  }

  function updateCartPageHTML(htmlText) {
    var cartPageContainer = document.querySelector('.cart-page__container');
    if (!cartPageContainer) return;

    var parser = new DOMParser();
    var doc = parser.parseFromString(htmlText, 'text/html');
    var newContainer = doc.querySelector('.cart-page__container') || doc.body.firstElementChild;
    if (newContainer && cartPageContainer) {
      cartPageContainer.innerHTML = newContainer.innerHTML;

      // Make reveal-on-scroll elements visible immediately
      cartPageContainer.querySelectorAll('.reveal-on-scroll').forEach(function (el) {
        el.classList.add('is-visible');
      });

      // Unlock body and popup states if stuck
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.classList.remove('variant-popup-open');
      document.documentElement.classList.remove('variant-popup-open');

      if (window.initScrollReveal) {
        window.initScrollReveal(cartPageContainer);
      }

      if (window.Swiper) {
        document.querySelectorAll('.cart-recommendations').forEach(function (section) {
          var el = section.querySelector('.cart-recs-swiper');
          if (el) {
            new Swiper(el, {
              slidesPerView: 2,
              spaceBetween: 12,
              freeMode: true,
              mousewheel: { forceToAxis: true },
              breakpoints: {
                480: { slidesPerView: 3, spaceBetween: 16 },
                768: { slidesPerView: 4, spaceBetween: 20 },
                1024: { slidesPerView: 6, spaceBetween: 24 },
              },
            });
          }
        });
      }

      // Rebind cart.liquid's own controls (qty stepper stock limits, sticky
      // checkout bar, GWP freebie fab/panel) lost when innerHTML is replaced.
      if (typeof window.reinitCartPageControls === 'function') {
        window.reinitCartPageControls();
      }
    }
  }

  function refreshCartPage() {
    var cartPageContainer = document.querySelector('.cart-page__container');
    if (!cartPageContainer) return;

    fetch(window.location.href)
      .then(function (res) { return res.text(); })
      .then(function (htmlText) {
        updateCartPageHTML(htmlText);
      })
      .catch(function (err) {
        console.error('Error updating cart view:', err);
      });
  }

  function showAddedState(btn) {
    if (!btn) return;
    /* Preserve SVG/icon markup — textContent would wipe it permanently. */
    if (!btn.dataset.originalHtml) {
      btn.dataset.originalHtml = btn.innerHTML;
    }
    btn.textContent = 'ADDED!';
    btn.classList.add('is-added');
    setTimeout(function () {
      btn.innerHTML = btn.dataset.originalHtml;
      btn.classList.remove('is-added');
    }, 1800);
  }

  function updateCartCount() {
    if (window.BohopanaCart && typeof window.BohopanaCart.refreshFromCart === 'function') {
      return window.BohopanaCart.refreshFromCart();
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-action-btn__badge').forEach(function (badge) {
          badge.textContent = cart.item_count > 0 ? '+' + cart.item_count : '';
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }

  /* ---- Helpers ---- */
  function formatMoney(cents) {
    return 'Rp' + Math.round(cents / 100)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* ================================================================
     PRODUCT CARD SKELETON LOADER
     Handles fading out and removing skeletons once image loads.
  ================================================================ */
  function initSkeletonLoaders() {
    // Handled natively via CSS + HTML onload attribute inside product-card.liquid
  }

  /* ================================================================
     INIT
     ================================================================ */
  function initProductCardFeatures() {
    initCountdowns();
    initFeaturedCarousels();
    initSkeletonLoaders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardFeatures);
  } else {
    initProductCardFeatures();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-countdown][data-countdown-bound]').forEach(function (el) {
      delete el.dataset.countdownBound;
    });
    document.querySelectorAll('[data-flash-sale-section][data-flash-sale-bound]').forEach(function (el) {
      delete el.dataset.flashSaleBound;
    });
    initCountdowns();
  });
})();
